/**
 * Language, internationalization and text direction helpers.
 */

export const SUPPORTED_LANGUAGES = Object.freeze(['fr', 'ar']);
export const DEFAULT_LANGUAGE = 'fr';

/**
 * Returns text direction for a given language code.
 *
 * @param {string} language
 * @returns {'ltr' | 'rtl'}
 */
export function getTextDirection(language) {
  return language === 'ar' ? 'rtl' : 'ltr';
}

/**
 * Normalizes a language code to an allowed supported language.
 *
 * @param {string} lang
 * @returns {'fr' | 'ar'}
 */
export function normalizeLanguage(lang) {
  if (!lang || typeof lang !== 'string') {
    return DEFAULT_LANGUAGE;
  }
  const clean = lang.toLowerCase().trim().slice(0, 2);
  return clean === 'ar' ? 'ar' : 'fr';
}

/**
 * Resolves a localized string from an object with language keys (e.g. { fr: '...', ar: '...' }).
 *
 * @param {object|string} localizedField
 * @param {string} [language='fr']
 * @returns {string}
 */
export function getLocalizedText(localizedField, language = 'fr') {
  if (!localizedField) return '';
  if (typeof localizedField === 'string') return localizedField;
  
  const targetLang = normalizeLanguage(language);
  if (localizedField[targetLang]) {
    return localizedField[targetLang];
  }
  
  // Fallback to French or first available key
  return localizedField.fr || localizedField.ar || Object.values(localizedField)[0] || '';
}
